import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  breakpoints,
  Button,
  PictogramRegularHeartNone,
  Text,
} from '@notino/react-styleguide';

import { wishlistMessages } from '@containers/WishList/components/messages';
import { trackEmptyWishList } from '@containers/WishlistLists/tracking';
import { useTrackingContext } from '@context/tracking/TrackingContext';
import { styled } from '@linaria/react';

const Wrapper = styled.div`
  height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const StyledSubText = styled(Text)`
  max-width: 300px;
  @media (min-width: ${breakpoints.md}) {
    max-width: none;
  }
`;

export const Empty = ({ isDefaultList }: { isDefaultList: boolean }) => {
  const { getTimeFromInit } = useTrackingContext();

  const onEmptyWishListClick = () => {
    trackEmptyWishList({
      timing: getTimeFromInit(),
      mode: isDefaultList ? 'default' : 'custom',
    });
  };

  return (
    <Wrapper>
      <PictogramRegularHeartNone height="58px" width="58px" />

      <Text
        typography="titleLarge"
        color="text.primary"
        marginBottom="8px"
        marginTop="16px"
      >
        <FormattedMessage {...wishlistMessages.emptyWishlistMessage} />
      </Text>

      <StyledSubText
        typography="labelRegular400"
        color="text.secondary"
        marginBottom="24px"
        textAlign="center"
      >
        <FormattedMessage {...wishlistMessages.emptyWishlistGuide} />
      </StyledSubText>

      <Button href="/" onClick={onEmptyWishListClick}>
        <FormattedMessage {...wishlistMessages.emptyWishlistButton} />
      </Button>
    </Wrapper>
  );
};
